import { LEARNING_PRODUCTS } from 'bundles/search-common/constants';

const isCreditOffered = (entityType: typeof LEARNING_PRODUCTS[keyof typeof LEARNING_PRODUCTS]) => {
  return entityType === LEARNING_PRODUCTS.Mastertrack || entityType === LEARNING_PRODUCTS.GraduateCertificate;
};

export default isCreditOffered;
